import React from 'react';
import AdminProtectedRoute from './AdminProtectedRoute';
import AdminLayout from './AdminLayout';
import UserManagementTable from './UserManagementTable';
import AppUsageReport from './Admin/AppUsageReport';

/**
 * AdminPanel component
 * Main container for admin user management
 */
const AdminPanel = () => {
  return (
    <AdminProtectedRoute>
      <AdminLayout>
        <UserManagementTable />
        <AppUsageReport />
      </AdminLayout>
    </AdminProtectedRoute>
  );
};

export default AdminPanel;